import { Input } from '@/view/components/ui/input'
import { ChevronLeft, ChevronRight, Search } from 'lucide-react'
import useLinks from './useLinksController'
import { Button } from '@/view/components/ui/button'
import { Spinner } from '@/view/components/ui/spinner'
import { formatMoneyValue } from '@/app/utils/formatMoneyValue'
import QRCodeModal from './components/QRCodeModal'
import CreateLinkModal from './components/CreateLinkModal'
import { Links as LinksType } from '@/app/services/selfHireService/getAllUserLinks'

const Links = () => {
  const {
    data,
    isFetching,
    handleSearchInputChange,
    searchValue,
    isModalOpen,
    selectedLink,
    isCreateLinkModalOpen,
    newLinkName,
    selectedTables,
    setIsCreateLinkModalOpen,
    setNewLinkName,
    setSelectedTables,
    handleOpenModal,
    handleCloseModal,
    handleCreateLink,
    isPending,
    handleLinkClick,
    page,
    totalPages,
    handleNext,
    handlePrevious,
  } = useLinks()

  const hasLinks = !!data?.links && data.links.length > 0

  return (
    <div className="flex w-full max-w-[480px] flex-col items-start rounded-2xl border border-gray01 p-8">
      <div className="flex flex-col gap-2 ">
        <h2 className="text-xl font-semibold text-black01">
          Links de autocontratação
        </h2>
        <p className="text-sm font-medium text-black01">
          Gere seu link de autocontratação e envie ao cliente. Ele contrata de
          forma simples e segura, quando quiser, enquanto você acompanha tudo
          pelo app e recebe sua comissão automaticamente. Prático e seguro!
        </p>
      </div>

      {isFetching && !data ? (
        <div className="flex w-full items-center justify-center py-12">
          <Spinner />
        </div>
      ) : (
        <>
          {!hasLinks && !isFetching ? (
            <div className="mx-auto max-w-[340px]">
              <div className="mt-8 flex w-full flex-col items-center justify-center py-12">
                <i className="fa-solid fa-link mr-2 text-2xl" />
                <h3 className="mb-2 mt-2 text-base font-semibold text-gray-900">
                  Nenhum link criado ainda
                </h3>
                <p className="mb-6 text-center text-base font-medium text-gray-500">
                  Crie seu primeiro link de autocontratação
                  <br />e compartilhe com seus clientes
                </p>
                <Button
                  className="w-full bg-primary text-base font-bold hover:bg-primary"
                  onClick={() => setIsCreateLinkModalOpen(true)}
                >
                  <i className="fa-solid fa-link mr-2" />
                  Criar link
                </Button>
              </div>
            </div>
          ) : (
            <>
              <div className="w-full">
                <Button
                  className="my-5 w-full bg-primary text-base font-bold hover:bg-primary"
                  onClick={() => setIsCreateLinkModalOpen(true)}
                >
                  <i className="fa-solid fa-link mr-2" />
                  Criar novo link
                </Button>
                <div className="relative flex w-full items-center">
                  <Search size={20} className="z-2 absolute left-4 top-3" />
                  <Input
                    className="w-full rounded-lg pl-10"
                    placeholder="Pesquisar"
                    onChange={handleSearchInputChange}
                    value={searchValue}
                  />
                </div>
              </div>
              <div className="mt-5 w-full space-y-4">
                {data?.links.map((link: LinksType) => (
                  <div
                    key={link._id}
                    className="flex items-center justify-between border-b border-gray01 pb-4 last:border-b-0"
                  >
                    <div
                      className="flex flex-1 cursor-pointer flex-col items-start"
                      onClick={() => handleLinkClick(link)}
                    >
                      <p className="mb-2 text-base font-semibold text-black01">
                        {link.name}
                      </p>
                      <div className="flex items-center gap-5">
                        <p className="text-sm font-medium text-black04">
                          Acessos:
                          <span className="ml-1 font-semibold text-black01">
                            {Array.isArray(link.entry_count)
                              ? link.entry_count.length
                              : (link.entry_count ?? 0)}
                          </span>
                        </p>
                        <p className="text-sm font-medium text-black04">
                          Valor contratado:
                          <span className="ml-1 font-semibold text-black01">
                            {formatMoneyValue(link.total_transactions ?? 0)}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div>
                      <Button
                        variant="ghost"
                        className="bg-white02 p-2 hover:bg-white02"
                        onClick={() => handleOpenModal(link)}
                      >
                        <i className="fa-solid fa-qrcode text-xl text-black03"></i>
                      </Button>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-4 flex w-full justify-end">
                <div className="flex items-center gap-2">
                  <Button
                    variant="ghost"
                    onClick={handlePrevious}
                    disabled={page === 1}
                  >
                    <ChevronLeft />
                  </Button>
                  <div className="mx-4 flex gap-2">
                    {page} de {totalPages}
                  </div>
                  <Button
                    variant="ghost"
                    onClick={handleNext}
                    disabled={page === totalPages}
                  >
                    <ChevronRight />
                  </Button>
                </div>
              </div>
            </>
          )}
        </>
      )}

      <QRCodeModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        linkName={selectedLink.name}
      />
      <CreateLinkModal
        visible={isCreateLinkModalOpen}
        newLinkName={newLinkName}
        setNewLinkName={setNewLinkName}
        selectedTables={selectedTables}
        setSelectedTables={setSelectedTables}
        onCreateLink={handleCreateLink}
        isLoading={isPending}
        onClose={() => setIsCreateLinkModalOpen(false)}
      />
    </div>
  )
}

export default Links
